import React, { useState } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import Iconfont from '@/components/iconfont/iconfont'
import { useFormikContext } from 'formik'
import { IPakageForm, IPackageGoodsList } from '../../package-type'
import { getBEMCls } from '@/utils/classname'
import Big from 'big.js'

import '../../edit-package.scss'
import { Row } from '@/components/layout/layout'
import { useUpdateEffect } from 'ahooks'
import classNames from 'classnames'
import { useCheckForm } from '@/utils/form'
import CascaderTooltip from '@/components/input/cascader-tooltip'
import { useSelectGoods } from '@/views/main/modules/goods-manage/components/select-goods/select-goods'
import { WithInputLimit, INPUT_NUMBER_LIMIT_REGEXP } from '@/utils'

interface AddGoodTableProps {}

const AddGoodTable: React.FC<AddGoodTableProps> = props => {
    const { values, setFieldValue, handleBlur, handleChange } = useFormikContext<IPakageForm>()
    const [subtotal, setSubtotal] = useState<number>(0)
    const cls = (...args: string[]) => getBEMCls('edit-package', ...args)

    const { reduceGoods } = useSelectGoods()

    useUpdateEffect(() => {
        if (!values.package_goods_list.length) return
        const subtotal = values.package_goods_list.reduce((pre, next) => {
            return +Big(+next.amount || 0)
                .times(+next.price || +next.pricing_methods[0].sale_prices[0].sale_price || 0)
                .plus(pre)
        }, 0)
        setSubtotal(subtotal)
    }, [values.package_goods_list])

    const columns: ColumnsType<IPackageGoodsList> = [
        {
            title: '#',
            key: 'index',
            width: 40,
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'name',
            render: (value, record) => record.name,
        },
        {
            title: '单价',
            key: 'price',
            align: 'right',
            render: (value, record, index) => {
                const salePrice = record.pricing_methods.map(i => ({
                    ...i,
                    label: `${i.sale_prices[0].sale_price}元`,
                }))

                return (
                    <CascaderTooltip
                        list={salePrice}
                        fieldNames={{
                            key: 'sale_prices[0].id',
                            label: 'label',
                            value: 'sale_prices[0].sale_price',
                        }}
                        onItem={key => {
                            setFieldValue(`package_goods_list[${index}].price`, key)
                        }}
                    >
                        <div className={cls('price-input')} data-cursor-pointer>
                            {record.price || record.pricing_methods[0].sale_prices[0].sale_price}元/
                            {record.pricing_methods[0].sales_unit.name}
                            {salePrice.length > 1 && (
                                <Iconfont
                                    name="icon6xiala2-20"
                                    size={14}
                                    style={{
                                        marginLeft: '2px',
                                    }}
                                />
                            )}
                        </div>
                    </CascaderTooltip>
                )
            },
        },
        {
            title: '组合量',
            key: 'amount',
            align: 'right',
            render: (value, record, index) => {
                return WithInputLimit(
                    <input
                        // tslint:disable-next-line:max-line-length
                        name={`package_goods_list[${index}].amount`}
                        // tslint:disable-next-line:max-line-length
                        value={record.amount || ''}
                        onChange={handleChange}
                        autoComplete="off"
                        onBlur={handleBlur}
                        placeholder="请输入"
                        className={cls('table', 'input')}
                        type="text"
                    />,
                    INPUT_NUMBER_LIMIT_REGEXP,
                )
            },
        },
        {
            title: '小计',
            key: 'subtotal',
            align: 'right',
            render: (value, record, index) => {
                const { price, amount } = record

                return `¥${+Big(+price || record.pricing_methods[0].sale_prices[0].sale_price).times(+amount || 0)}`
            },
        },
        {
            title: '',
            key: 'icon',
            align: 'center',
            width: 30,
            render: (value, record, index) => (
                <Iconfont
                    onClick={() => {
                        const { package_goods_list } = values
                        package_goods_list.splice(index, 1)
                        reduceGoods(record.id)
                        setFieldValue(`package_goods_list`, JSON.parse(JSON.stringify(package_goods_list)))
                    }}
                    name="icon6yichu-20"
                    size={20}
                />
            ),
        },
    ]

    const { getErrorStr } = useCheckForm<IPakageForm>()

    return (
        <div className={cls('table', 'container')}>
            <Table
                rowKey={record => record.goods_id}
                dataSource={values.package_goods_list}
                bordered
                pagination={false}
                columns={columns}
            ></Table>
            {!!subtotal && (
                <Row className={cls('subtotal')}>
                    单品总计：
                    <div data-linline className={cls('subtotal', 'price')}>
                        ¥{subtotal}
                    </div>
                </Row>
            )}
            <span data-padding-top-8 className={classNames(cls('form-item', 'error'))}>
                {getErrorStr(`package_goods_list`)}
            </span>
        </div>
    )
}

export default AddGoodTable
